import { useEffect, useState } from 'react';
import API_URL from '@/config/api';

export function useEmbedFormConfig(key, fallback) {
  const [cfg, setCfg] = useState(fallback);
  useEffect(() => {
    fetch(`${API_URL}/api/public/embed-form-config/${key}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (data) setCfg((c) => ({ ...c, ...data })); })
      .catch(() => {});
  }, [key]);
  return cfg;
}
